import { seoSections } from '@/mocks/categories';

export default function WhatIsSection() {
  const { whatIs } = seoSections;

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 lg:order-1 animate-fade-in-up">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20photography%20of%20organized%20fashion%20moodboard%20with%20fabric%20texture%20swatches%20in%20neutral%20earth%20tones%20wooden%20buttons%20leather%20samples%20scissors%20and%20measuring%20tape%20on%20light%20oak%20surface%20creative%20design%20studio%20atmosphere%20natural%20window%20light%20casting%20soft%20shadows%20artisan%20craftsmanship%20aesthetic%20warm%20beige%20palette&width=800&height=600&seq=kakobuy-whatis-img&orientation=landscape"
                alt="Kakobuy Spreadsheet w użyciu"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <p className="text-sm font-semibold text-primary-500 uppercase tracking-wider mb-3">Kakobuy Spreadsheet</p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-6">
              {whatIs.title}
            </h2>
            <div className="space-y-4">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {whatIs.content}
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {whatIs.extended}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}